module.exports = __webpack_public_path__ + "img/result-icon.9edd336b.png";